<div class="w-100 h-100 d-flex align-items-center justify-content-center"
    *ngIf="!detailService.originalQuoteProductsFlat">
    <mat-spinner diameter="120" class="text-primary"></mat-spinner>
    <div class="font-italic text-muted">Loading original quote data...</div>
</div>
<div class="w-100" *ngIf="detailService.originalQuoteProductsFlat">
    <ng-container *ngLet="diffData$ | async as data">
        <mat-list class="pt-0" *ngIf="data && data !== false">
            <mat-list-item class="border-bottom change-item" *ngFor="let item of data"
                [ngClass]="[
                    item.changeType === 0 ? 'removed' : item.changeType === 1 ? 'modified' : item.changeType === 2 ? 'added' : '',
                    item.itemType === 0 ? 'item--labor' : item.itemType === 1 ? 'item--process' : item.itemType === 2 ? 'item--purchased' : item.itemType === 3 ? 'item--material' : '',
                ]">
                <div class="change-type-notch">&nbsp;</div>
                <div class="change-type-badge mr-2">{{ item.changeType === 0 ? 'Removed' : item.changeType === 1 ? 'Modified' : item.changeType === 2 ? 'Added' : '' }}</div>
                <mat-icon class="mr-2" [svgIcon]="item.itemType === 0 ? 'account-hard-hat' : item.itemType === 1 ? 'logout-variant' : item.itemType === 2 ? 'package-variant' : item.itemType === 3 ? 'cube' : '' "></mat-icon>
                <div class="item-name">{{ item.name }}</div>
                <div class="ml-auto">&nbsp;</div>
                <div class="small font-weight-medium" *ngIf="item.hoursChange !== null">
                    {{ item.hoursChange >= 0 ? '+' : '' }}{{ item.hoursChange.toFixed(2) }} hours / {{ item.priceChange > 0 ? '+' : '' }}{{ item.priceChange | currency }}
                </div>
                <div class="small font-weight-medium" *ngIf="item.hoursChange == null">
                    {{ item.priceChange >= 0 ? '+' : '' }}{{ item.priceChange | currency }}
                </div>
            </mat-list-item>
            <mat-list-item class="border-bottom text-muted small font-italic" *ngIf="data.length === 0">
                No changes from the estimate were found.
            </mat-list-item>
        </mat-list>
        <div class="w-100 text-muted small font-italic" *ngIf="data === false">This part number was not found on the
            quote the PO was made against.</div>
    </ng-container>
</div>